const BR = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.CPF",
      visible: true,
      required: true,
    },
    accountNumber: {
      visible: true,
      label: "bankDetails.accountNumber",
      placeholder: "bankDetails.acountNumberPlaceholderBr",
      required: true,
    },
    bankCode: {
      visible: false,
      required: false,
    },
    IBAN: {
      visible: false,
      required: false,
    },
    ClaveBanco: {
      label: "bankDetails.ClaveBanco",
      placeholder: "bankDetails.ClaveBancoPlaceholderBr",
      visible: true,
      required: true,
    },
    accountHolderName: {
      required: false,
      visible: false,
      label: "bankDetails.accountHolderName",
    },
    swift: {
      visible: true,
      label: "bankDetails.swift",
      placeholder: "bankDetails.swiftMinmaxValidation",
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    banckName: {
      label: "bankDetails.banckName",
      visible: true,
      required: true,
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
  },
};
export { BR };
